import React from 'react';
import AtlasModal, {
  ModalTransition as AtlasModalTransition,
} from '@atlaskit/modal-dialog';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

import { Close } from '../styles';
import Row from '../../../Common/Row';
import Inputs from '../../../Inputs';
import ShowPassword from '../../../ShowPassword';
import InputError from '../../../InputError';

const Modal = ({
  isOpen,
  close,
  onSubmit,
  onCancel,
  isLoading,
  currentPassword,
  onCurrentPasswordChanged,
  newPassword,
  onNewPasswordChanged,
  newPasswordErrors,
  isHidingPassword,
  setIsHidingPassword,
  hasWrongPassword,
  isValid,
}: {
  isOpen: boolean;
  close: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  hasWrongPassword: boolean;
  isLoading: boolean;
  currentPassword: string;
  onCurrentPasswordChanged: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  newPassword: string;
  onNewPasswordChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
  newPasswordErrors: string[] | undefined;
  isHidingPassword: boolean;
  setIsHidingPassword: React.Dispatch<React.SetStateAction<boolean>>;
  isValid: boolean;
}) => (
  <AtlasModalTransition>
    {isOpen && (
      <AtlasModal
        onClose={close}
        autoFocus={false}
        shouldScrollInViewport={false}
      >
        <div
          style={{ padding: 32, position: 'relative' }}
          id="change-password-modal"
        >
          <div style={{ marginBottom: 24 }}>
            <Typography.Header type="H5">Change password</Typography.Header>
          </div>
          <Close>
            <Button onClick={onCancel} type="Ghost" size="Small" icon="cross" />
          </Close>
          <div>
            <div style={{ marginBottom: 16 }}>
              <Typography.Body type="Label">Current Password</Typography.Body>
              <div style={{ position: 'relative' }}>
                <Inputs.TextInput
                  value={currentPassword}
                  onChange={onCurrentPasswordChanged}
                  type={isHidingPassword ? 'password' : 'text'}
                  // @ts-ignore
                  autocomplete="current-password"
                  width="100%"
                />
                <ShowPassword
                  isHiding={isHidingPassword}
                  setIsHiding={setIsHidingPassword}
                />
              </div>
              {hasWrongPassword && (
                <InputError text={'Please enter the correct password'} />
              )}
            </div>
            <div style={{ marginBottom: 32 }}>
              <Typography.Body type="Label">New Password</Typography.Body>
              <div style={{ position: 'relative' }}>
                <Inputs.TextInput
                  value={newPassword}
                  onChange={onNewPasswordChanged}
                  type={isHidingPassword ? 'password' : 'text'}
                  // @ts-ignore
                  autocomplete="new-password"
                  width="100%"
                />
                <ShowPassword
                  isHiding={isHidingPassword}
                  setIsHiding={setIsHidingPassword}
                />
              </div>
              {newPasswordErrors && (
                <div style={{ marginTop: 4 }}>
                  {newPasswordErrors.map((pe) => (
                    <InputError text={pe} key={Math.random()} />
                  ))}
                </div>
              )}
            </div>
            <Row style={{ justifyContent: 'flex-end' }}>
              <Button
                onClick={onCancel}
                isLoading={isLoading}
                isDisabled={isLoading}
                type="Ghost"
                size="Small"
                label="Cancel"
              />
              <div style={{ marginRight: 8 }} />
              <Button
                isLoading={isLoading}
                isDisabled={isLoading || !isValid}
                onClick={onSubmit}
                label="Save"
                type="Primary"
                size="Small"
              />
            </Row>
          </div>
        </div>
      </AtlasModal>
    )}
  </AtlasModalTransition>
);

export default Modal;
